var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChewronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconChewron",
    clipPath: "url(#clip0_9196_61457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21582 3.34061C8.09675 3.2198 7.90325 3.2198 7.78418 3.34061L0.0888831 11.1481C-0.0296281 11.2684 -0.029628 11.4629 0.0888832 11.5831L1.14967 12.6594C1.26875 12.7802 1.46224 12.7802 1.58132 12.6594L7.85612 6.29308C7.9355 6.21254 8.0645 6.21254 8.14388 6.29308L14.4187 12.6594C14.5378 12.7802 14.7312 12.7802 14.8503 12.6594L15.9111 11.5831C16.0296 11.4629 16.0296 11.2684 15.9111 11.1481L8.21582 3.34061Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9196_61457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChewronUp);
export default __webpack_public_path__ + "static/media/iconChewronUp.40336060d4ae80c89ca6bb55d071c480.svg";
export { ForwardRef as ReactComponent };